import React, { useEffect, useState } from "react";
import ReactSwitch from "react-switch";
import { Divider } from "primereact/divider";
import {
  BASE_SIZE_MIN_VALUE,
  INDEX_SCORE_INDICATOR,
  toSentenceCase,
} from "../../../../utils/constants";
import DataTableSkeleton from "../../../Skeletons/DataTableSkeleton";

const ExperienceTable = ({ tableData, loading = false }) => {
  if (!tableData?.labels || !tableData?.datasets) return null;
  const categoryDataset = tableData.datasets.find(
    (dataset) => dataset.label.toUpperCase() === "CATEGORY",
  );
  const [headers, setHeaders] = useState([]);
  const [headersNValue, setHeadersNValue] = useState([]);

  useEffect(() => {
    if (tableData?.datasets && tableData?.datasets.length) {
      let tableHeaders = tableData.datasets;
      const tableHeadersData = [
        "",
        ...tableHeaders.map((dataset) => dataset.label.toUpperCase()),
      ];
      const tableHeadersNData = [
        "",
        ...tableHeaders.map((dataset) =>
          dataset?.participant && dataset?.participant.length
            ? dataset.participant[0]
            : 0,
        ),
      ];
      setHeaders(tableHeadersData);
      setHeadersNValue(tableHeadersNData);
    }
  }, [tableData?.datasets]);

  const transformedData = tableData.labels.map((label, index) => {
    const row = { rowHeader: label };

    tableData.datasets.forEach((dataset, i) => {
      const originalValue = dataset.data[index];
      // const categoryValue = categoryDataset?.data[index] || 1;
      // const ratio = (originalValue / categoryValue) * 100;
      row[dataset.label] = {
        value:
          label.toLowerCase() === "total uses surveyed" ||
          label.toLowerCase() === "mean"
            ? `${originalValue}`
            : `${originalValue}`,
        className: `text-secondary fw-bold ${label.toLowerCase() === "total uses surveyed" ? "fst-italic" : ""} ${label.toLowerCase() === "mean" ? "text-dark table-col-bg-color" : ""}`,
      };
    });

    return row;
  });

  return (
    <div className="mt-4" style={{ maxWidth: "100%" }}>
      <div className="mb-4">
        {loading ? (
          <DataTableSkeleton />
        ) : (
          <>
            <div className="table-responsive">
              <table
                className="table text-center"
                style={{ minWidth: "600px", tableLayout: "auto" }}
              >
                <thead className="thead-light">
                  <tr style={{ borderBottom: "1px solid #dee2e6" }}>
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        style={{
                          color:
                            index !== 0
                              ? headersNValue[index] < BASE_SIZE_MIN_VALUE
                                ? "#6c757d" // previous color #dc3545(red)
                                : "#6c757d"
                              : "#6c757d",
                          // position: index === 0 ? "sticky" : "static",
                          left: index === 0 ? 0 : "auto",
                          background: "#fff",
                          zIndex: index === 0 ? 2 : "auto",
                          width: index === 0 ? "250px" : "auto",
                          minWidth: index === 0 ? "250px" : "auto",
                        }}
                      >
                        <div className="header-name">
                          {toSentenceCase(header)}
                          <br />
                          {index !== 0 ? (
                            <>
                              (n={headersNValue[index]} XMOT<sup>&reg;</sup>{" "}
                              surveys)
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                  <tr style={{ borderBottom: "1px solid #dee2e6" }}>
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        style={{
                          color: "#6c757d",
                          // position: index === 0 ? "sticky" : "static",
                          left: index === 0 ? 0 : "auto",
                          background: "#fff",
                          zIndex: index === 0 ? 2 : "auto",
                          width: index === 0 ? "250px" : "auto",
                          minWidth: index === 0 ? "250px" : "auto",
                        }}
                      >
                        {index === 0 ? "" : "%"}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transformedData.map((row, index) => (
                    <tr className="table-row" key={index}>
                      <td
                        className={`${row.rowHeader === "Total uses surveyed" ? "fst-italic " : ""}fw-bold text-start`}
                        style={{
                          color: "#4A5057",
                          // position: "sticky",
                          left: 0,
                          background:
                            row.rowHeader === "Mean"
                              ? "rgb(241 242 242)"
                              : "#fff",
                          zIndex: 2,
                        }}
                      >
                        {row.rowHeader}
                      </td>
                      {tableData.datasets.map((dataset, dindex) => (
                        <td
                          key={dindex}
                          style={{
                            background: dindex === 0 ? "rgb(241 242 242)" : "",
                          }}
                          className={row[dataset.label].className}
                        >
                          {row[dataset.label].value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
        <Divider />
      </div>
    </div>
  );
};

export default ExperienceTable;
